import PointTransaction from './PointTransaction';

class PointTransactionHistory {
  public readonly monthly: Map<string, PointTransaction[]>;
  public readonly childrenPoints: Map<string, Map<string, number>>;
  constructor({
    monthly,
    childrenPoints,
  }: {
    monthly: Map<string, PointTransaction[]>;
    childrenPoints: Map<string, Map<string, number>>;
  }) {
    this.monthly = monthly;
    this.childrenPoints = childrenPoints;
  }

  public static fromJSON = (value: any) => {
    const { your, children } = Object.assign({}, value);

    if (typeof your !== 'object' || typeof children !== 'object')
      throw new TypeError('point_transaction data struct is invalid');
    const monthly = new Map<string, PointTransaction[]>();
    const childrenPoints = new Map<string, Map<string, number>>();

    Object.keys(children).forEach((id: string) => {
      const ch = new Map<string, number>();
      Object.keys(children[id]).forEach((m: string) => {
        let sumPoints = 0;
        Object.values(children[id][m]).forEach((n: any) => (sumPoints += Number(n)));
        ch.set(m, sumPoints);
      });
      childrenPoints.set(id, ch);
    });

    if (Object.keys(your).length === 0) return new PointTransactionHistory({ monthly, childrenPoints });

    const orgId = Object.keys(your)[0];
    if (typeof your[orgId] !== 'object') throw new TypeError('point_transaction data struct is invalid');

    Object.keys(your[orgId]).forEach((m: string) => {
      if (typeof your[orgId][m]['data'] !== 'object') throw new TypeError('point_transaction data struct is invalid');
      if (!monthly.get(m)) {
        monthly.set(m, []);
      }
      your[orgId][m]['data'].forEach((pt: any) => monthly.get(m)!.push(PointTransaction.fromJSON(pt)));
    });

    return new PointTransactionHistory({
      monthly,
      childrenPoints,
    });
  };
}

export default PointTransactionHistory;
